// extracted by mini-css-extract-plugin
module.exports = {"scrollTop":"ScrollToTop_scrollTop__efZv8","fadeIn":"ScrollToTop_fadeIn__u-lQp"};